import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;
    const hash = window.location.hash;
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    (async () => {
      try {
        if (!sessionId) throw new Error("no session");
        const user = await api.post("/auth/session", {}, { headers: { "X-Session-ID": sessionId } });
        setUser(user);
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true, state: { user } });
      } catch {
        navigate("/login", { replace: true });
      }
    })();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen bg-[#09090b] flex items-center justify-center text-zinc-500 gap-2 font-mono text-sm">
      <Loader2 className="h-4 w-4 animate-spin" /> Establishing session…
    </div>
  );
}
